const buttonTarget = '.wm-openSubchapterButton > a';
var offset = 0;
const scrollDuration = 1000;
jQuery(document).on('ready', function () {
    jQuery(buttonTarget).on('click', function () {
        let target = jQuery(this).attr('href');
        jQuery(target).removeClass('-subchapterHidden');
        var windowSize = jQuery(window).width();
        if (windowSize < 1025) {
            offset = 50;
        }
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(target).offset().top - offset
        }, scrollDuration);
    });
});
